export default {
  aria_skip_to_main_content: 'Aller au contenu principal',
  aria_main_navigation: 'Navigation principale',
  aria_user_navigation: 'Navigation utilisateur',
  aria_mobile_navigation_toggle: 'Basculer le menu de navigation mobile',
  aria_mobile_navigation_menu: 'Menu de navigation mobile',
  aria_dropdown_menu: 'Menu déroulant',
  aria_submenu: 'Sous-menu {name}',
  more: 'Plus',
  lang_chooser: {
    aria_label: 'Sélecteur de langue',
    lang_switch: 'Navigate in',
  },
};
